import script from "./QuizMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizMobile.vue?vue&type=script&setup=true&lang=js"

import "./QuizMobile.vue?vue&type=style&index=0&id=351d3cf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-351d3cf8"]])

export default __exports__